import { render } from "./globe-button.vue?vue&type=template&id=02e0b050&scoped=true"
import script from "./globe-button.vue?vue&type=script&lang=js"
export * from "./globe-button.vue?vue&type=script&lang=js"

import "./globe-button.vue?vue&type=style&index=0&id=02e0b050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e0b050"]])

export default __exports__